import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";

export const AccordionItem = ({ q, a, testid, dark = false }) => {
    const [open, setOpen] = useState(false);
    return (
        <div className={`border-b ${dark ? "border-chalk/15" : "border-graphite/15"}`}>
            <button
                data-testid={testid}
                onClick={() => setOpen(!open)}
                aria-expanded={open}
                className="w-full flex items-center justify-between gap-6 py-6 text-left group"
            >
                <span className={`font-serif text-xl md:text-2xl font-light transition-colors duration-300 ${dark ? "text-chalk group-hover:text-gold" : "text-graphite group-hover:text-forest"}`}>
                    {q}
                </span>
                <motion.span
                    animate={{ rotate: open ? 45 : 0 }}
                    transition={{ duration: 0.4, ease: [0.65, 0, 0.35, 1] }}
                    className={`shrink-0 ${dark ? "text-gold" : "text-gold"}`}
                >
                    <Plus size={18} strokeWidth={1.5} />
                </motion.span>
            </button>
            <AnimatePresence initial={false}>
                {open && (
                    <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.45, ease: [0.65, 0, 0.35, 1] }}
                        className="overflow-hidden"
                    >
                        <p className={`pb-7 pr-10 font-sans text-sm md:text-base leading-relaxed ${dark ? "text-fog" : "text-slate"}`}>
                            {a}
                        </p>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
};

export const Accordion = ({ items, testidPrefix, dark = false }) => (
    <div className={`border-t ${dark ? "border-chalk/15" : "border-graphite/15"}`} data-testid={`${testidPrefix}-accordion`}>
        {items.map((item, i) => (
            <AccordionItem key={i} q={item.q} a={item.a} dark={dark} testid={`${testidPrefix}-item-${i}`} />
        ))}
    </div>
);
